<template>
  <el-container>
    <!-- <el-header height="48px" style="line-height: 48px">
      <span class="title">概况</span>
      <el-tooltip class="item" effect="dark" content="交期、缺货相关数据统计分析都是针对已审未交订单。" placement="top-start">
        <span class="el-icon-warning-outline"></span>
      </el-tooltip>
    </el-header> -->
    <el-main v-loading="JSON.stringify(data) === '{}'">
      <el-row type="flex">
        <el-col class="overview-item">
          <div class="label">已审未交订单数</div>
          <div class="value high-light" @click="changeTab('orders', '')">{{data.reviewedNum}}</div>
        </el-col>
        <el-col class="overview-item">
          <div class="label">未审订单数</div>
          <div class="value">{{data.unReviewedNum}}</div>
        </el-col>
        <el-col class="overview-item">
          <div class="label">缺货订单数</div>
          <div class="value">
            <span class="high-light" @click="changeTab('orders', true)">{{data.stockOutOrderNum}}</span>
            <span class="percent">{{data.proportion && data.proportion.split('%')[0]}}</span>
          </div>
        </el-col>
        <el-col class="overview-item">
          <div class="label">缺货产品数</div>
          <div class="value high-light" @click="changeTab('products', true)">{{data.stockOutProductNum}}</div>
        </el-col>
        <!-- <el-col class="overview-item">
          <div class="label">缺货套件数</div>
          <div class="value">{{data.stockOutSuitNum}}</div>
        </el-col> -->
        <el-col class="overview-item">
          <div class="label">缺货包件数</div>
          <div class="value high-light" @click="changeTab('packages', true)">{{data.stockOutPackNum}}</div>
        </el-col>
        <el-col class="overview-item">
          <div class="label">
            订单配送平均天数
            <el-tooltip class="item" effect="dark" content="上月的订单平均配送周期" placement="top-start">
              <span class="el-icon-warning-outline"></span>
            </el-tooltip>
          </div>
          <div class="value">
            {{data.aveOrderDay}}
            <i
              v-permission="`ec-pc-new$orderManagement$analysisOrderManage$analysisOrder$Edit the order delivery average days`"
              class="el-icon-edit"
              @click="editAveOrderDay"></i>
          </div>
        </el-col>
      </el-row>

      <v-dialog v-model="dialogVisible" :config="{ width: '35%', title: '修改平均天数', confirmCallback: true }" @dialogConfirm="dialogConfirm">
        <div slot="content">
          <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm">
            <el-form-item label="平均天数" prop="aveOrderDay">
              <el-input v-model.trim="form.aveOrderDay" clearable placeholder="填写平均天数"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </v-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { float3 } from '@/utils/validate'

import vDialog from '@/views/operationAnalysis/common/dialog'
export default {
  components: { vDialog },
  data() {
    const checkNum = (rule, value, callback) => {
      let status = float3(value);
      if(status) {
        value = value.includes('.') && value.split('.') || [value];
        if(value[0].length > 2) {
          callback(new Error('整数值不能超过两位数'));
          return;
        }

        if(value[1] && value[1].length > 1) {
          callback(new Error('小数点不能超过一位数'));
          return;
        }

        callback();

      }else{
        callback(new Error('数值不符合校验规则'))
      }
    }
    return {
      data: {},
      form: {
        aveOrderDay: null
      },
      dialogVisible: false,
      rules: {
        aveOrderDay: [
          { required: true, validator: checkNum,  }
        ]
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let data = {
        surveyVo: {}
      }
      this.$q.orderDate.deliveryOrderSurvey({data})
      .then(res=>{
        if(res.success === true && res.data) {
          this.data = res.data;
          this.$bus.$emit( 'tabNum', res.data)
        }
      })
    },
    changeTab(tabName, status) {
      this.$bus.$emit( 'changeTab', {tabName, status})
    },
    editAveOrderDay() {
      this.dialogVisible = true;
      this.form.aveOrderDay = this.data.aveOrderDay
    },
    dialogConfirm() {
      this.$refs['ruleForm'].validate(status=>{
        if(status) {
          this.submit();
        }else{

        }
      })
    },
    async submit() {
      this.dialogVisible = false;
      let data = {
        aveOrderDay: this.form.aveOrderDay
      };
      let res = await this.$q.orderDate.deliveryAveOrderDay({data})
      if(res.success === true) {
        this.$message({
          message: res.message,
          type: 'success'
        });
      }else{
        this.$message({
          message: res.message,
          type: 'warning'
        });
      }
      this.$nextTick(_=>{
        this.data = {};
        this.init();
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .el-container
    background #ffffff
    border-radius 4px
    overflow hidden

  >>> .el-main
    padding-top 10px !important

  .title
    font-size 18px
    font-weight bold
    line-height 36px
    color #444444
  >>> .el-icon-warning-outline
    font-size 16px

  .overview-item
    font-size 14px
    .label
      color #777777
    .value
      font-size 20px
      margin-top 10px
      color #444444
      .percent
        position relative
        font-size 20px
        color #444444
        display inline-block
        text-indent 8px
        &::before
          position absolute
          left 2px
          top 50%
          content ""
          height 16px
          width 1px
          background #e2e2e2
          transform translate(0, -50%)
        &::after
          position absolute
          right -12px
          bottom 2px
          content "%"
          font-size 14px

  .high-light
    cursor pointer

  >>> .el-icon-edit
    color #1890ff
    margin-left 10px
</style>
